import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from '@app-core/services/data/data.service';
import { InstallerParams, ManualDriversResponse, PaginationParams } from '@app-driver-management/common/driver-management.model';
import { INSTALLER_TABLE_PAGE_SIZE } from '@app-driver-management/common/Installer.constants';
import { DriverManagementService } from '@app-driver-management/services/driver-management.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-installers',
  templateUrl: './installers.component.html',
  styleUrls: ['./installers.component.scss'],
})
export class InstallersComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public installerList: ManualDriversResponse[] = [];
  public InstallerTablePageSize: number = INSTALLER_TABLE_PAGE_SIZE;
  public fleetId;
  public totalDrivers: number = 0;
  public searchControl: FormControl = new FormControl();
  public loader: boolean = true;
  public offset: number = 0;
  constructor(public dataService: DataService, private router: Router, private driverManagementService: DriverManagementService) {}

  ngOnInit(): void {
    this.dataService._currentFleet.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      this.fleetId = value;
    });
    this.getInstallerList();
    this.searchControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.ngUnsubscribe)).subscribe((search) => {
      this.getInstallerList(search);
    });
  }

  public getInstallerList(search: string = ''): void {
    this.loader = true;
    const isRefresh = true;
    const params: InstallerParams = {
      limit: this.InstallerTablePageSize,
      offset: this.offset,
      searchBy: 'INSTALLER',
      ...(search.trim() && { search: search.trim() }),
    };
    this.driverManagementService
      .getInstallerList(isRefresh, params)
      .pipe(
        finalize(() => {
          this.loader = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        (res) => {
          this.loader = false;
          this.installerList = res.rows;
          this.totalDrivers = res.totalCount;
        },
        () => {
          this.installerList = [];
          this.loader = false;
        }
      );
  }
  public dorefresh() {
    this.getInstallerList();
  }
  public navigateToEditInstaller(): void {
    this.router.navigate(['drivers/edit-installer'], {
      queryParams: { mode: 'add' },
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onPageChange(event: PaginationParams) {
    this.offset = event.offset;
    this.InstallerTablePageSize = event.limit;
    this.dorefresh();
  }
}
